import React, { useState, useEffect } from 'react'
import { withAuth } from '../AuthContext'
import { withSearch } from '../SearchContext'
import { withRouter } from 'react-router-dom'
import { gaEvents } from '../../analytics/events'
import { shouldTranslateTo } from '../../utils/utils'
import Cookies from 'universal-cookie'
import styled from 'styled-components'
import {
  ActionButtons,
  Title,
  Subtitle,
  TextArea,
} from '../Utils/CustomClasses'

const cookies = new Cookies()

const ContainerBox = styled.div`
  padding: 0 36px 55px 36px;
  background-color: transparent;

  @media (max-width: 799px) {
    padding: 0 25px 25px 25px;
  }
`

const OnboardingTitle = styled(Title)`
  font-family: 'Open Sans', sans-serif;
`

const OnboardingSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
`

const ProceedButton = styled(ActionButtons)`
  background-color: #0bac5d;
  margin: 26px auto 30px;
`

const LaterButton = styled(ActionButtons)`
  background-color: transparent;
  margin: 26px auto 30px;
`

const ErrorWrapper = styled.div`
  margin: 0;
  text-align: center;
`

const OnboardingError = styled.label`
    background-color: #ffff00;
    color: #ff0000;
    padding: 5px 10px;
    border-radius: 5px;
    margin: 0 4vw;
}
`

const IntroOnboarding = ({ data, onComplete }) => {
  const [pageText, setPageText] = useState([])
  const [loading, setLoading] = useState(false)
  const [intro, setIntro] = useState('')
  const [introError, setIntroError] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    gaEvents.eventGeneric(
      'page_load',
      'add-intro-page-loaded',
      data.auth.user.id + ' - add introduction - page loaded'
    )

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('profile-bio', language)
  }, [])

  const handleInputChange = (e) => {
    const target = e.target
    const name = target.name

    console.log('target: ' + target)
    console.log('name: ' + name)

    setError('')
    setIntroError(false)

    setIntro(e.target.value)
  }

  const handleSubmit = () => {
    setIntroError(false)

    if (!intro) {
      setIntroError(true)
      setError('Please add your message before proceeding.')
      return
    }

    setLoading(true)

    const userData = {
      userId: data.auth.user.id,
      memberIntroduction: intro,
    }

    const config = {
      headers: {
        Authorization: `Bearer ${window.sessionStorage.getItem('commAt')}`,
      },
    }

    axios
      .post(`/api/VYGVA82re2f8e2/memberpost`, userData, config)
      .then((response) => {
        if (response.data.success) {
          onComplete('db2&int=y')
        } else {
          setError('Your post failed to save. Please try submitting it again.')
          setLoading(false)
        }
      })
      .catch((err) => {
        console.log('Error adding post into Circle: ', err)
      })
  }

  const handleDoLater = () => {
    const userData = {
      circleIntroStatus: 'pending',
    }
    data.auth.updateUser(userData)

    onComplete('db2&int=n')
  }

  if (pageText.length === 0 || loading) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border onboarding-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
  return (
    <ContainerBox>
      <OnboardingTitle
        center
        color="#ff9900"
        size="34px"
        sizemd="34px"
        sizesm="34px"
        margin="30px 0 0"
        dangerouslySetInnerHTML={{
          __html: `Your message`,
        }}
      ></OnboardingTitle>

      <OnboardingSubtitle
        center
        color="#fff"
        size="16px"
        sizesm="16px"
        weight="200"
        margin="24px 0 30px"
        dangerouslySetInnerHTML={{
          __html: `The message will be posted into the Introductions space of the Freebird Community Hub. You can view, edit or delete your message at any time and you will be notified when other members respond.`,
        }}
      />

      <OnboardingSubtitle
        center
        color="#fff"
        size="16px"
        sizesm="16px"
        weight="200"
        margin="24px 0 20px"
        dangerouslySetInnerHTML={{
          __html: `Enter your message in the box below:`,
        }}
      />

      <TextArea
        id="intro"
        name="intro"
        rows="5"
        required
        margin="0 0 40px 0"
        placeholder={
          'Tell other members a little about yourself. E.G. Where you are from, what you like to do, where you have travelled and where you would like to travel next, why you joined Freebird Club etc. Other members can then reach out to say hello.'
        }
        value={intro}
        className={introError && 'empty-box'}
        onChange={(e) => handleInputChange(e)}
      />

      <ErrorWrapper>
        {error && <OnboardingError>{error}</OnboardingError>}
      </ErrorWrapper>

      <ProceedButton
        type="submit"
        padding="10px 60px"
        margin="46px 10vw 26px"
        fontsize="16px"
        onClick={() => {
          handleSubmit()
        }}
      >
        Submit message
      </ProceedButton>

      <LaterButton
        color="#a2a2a2"
        type="button"
        padding="10px 60px"
        margin="46px 10vw 26px"
        fontsize="14px"
        onClick={() => {
          handleDoLater()
        }}
      >
        I'll do this later
      </LaterButton>
    </ContainerBox>
  )
}

export default withRouter(withSearch(withAuth(IntroOnboarding)))
